import React from "react";
import { Link } from "react-router-dom";
import { Code2, FileText, Search } from "lucide-react";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2,
  BODY_SM,
  CARD_TITLE,
  INLINE_LINK,
} from "./sections";

const USE_CASES = [
  {
    icon: Code2,
    title: "Coding & technical",
    body: (
      <>
        Describe the function or problem in plain language, including
        constraints like language, libraries, or performance, then let the AI
        draft the code. It is often faster to explain a bug out loud than to
        type it precisely.
      </>
    ),
  },
  {
    icon: FileText,
    title: "Writing & content",
    body: (
      <>
        Voice prompting AI is a strong fit for content requests, since tone,
        audience, and structure are all easy to describe out loud and easy to
        forget when typing quickly. If you are drafting directly,{" "}
        <Link to="/voice-typing-for-google-docs" className={INLINE_LINK}>
          voice typing for Google Docs
        </Link>{" "}
        uses the same dictation and cleanup approach.
      </>
    ),
  },
  {
    icon: Search,
    title: "Research & summarizing",
    body: (
      <>
        Speak through what you already know and what you are trying to figure
        out. This thinking-out-loud context often produces a more targeted
        summary than a short typed request.
      </>
    ),
  },
];

const UseCasesSection = () => {
  return (
    <section
      id="use-cases"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2}>Voice Prompting AI Across Different Use Cases</h2>

      <div className="pt-[30.05px]">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-[17.17px] items-stretch">
          {USE_CASES.map(({ icon: Icon, title, body }) => (
            <article
              key={title}
              className="flex flex-col rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-white p-[16px] sm:p-[21.46px]"
            >
              <span className="flex h-[34.34px] w-[34.34px] items-center justify-center rounded-[12.88px] bg-[#EBF7FE] text-[#3AB1F6]">
                <Icon className="h-[16px] w-[16px]" strokeWidth={1.8} />
              </span>

              <h3 className={`mt-[17.17px] ${CARD_TITLE}`}>{title}</h3>
              <p className={`mt-[8px] ${BODY_SM}`}>{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
